<template>
  <transition name="fade">
    <div
      v-if="isShow"
      @click="handleClickOverlay"
      class="vc-overlay vue-confirm-dialog"
      id="vueConfirm"
    >
      <transition name="zoom">
        <div v-if="isShow" ref="vueConfirmDialog" class="vc-container">
          <span class="vc-text-grid">
            <img v-if="dialog.xclose" class="vc-close" @click.stop="e => handleClickButton(e, null)" src="~images_base/close.svg"></img>
            <h4 v-if="dialog.title" class="vc-title">{{ dialog.title }}</h4>
            <p v-if="dialog.message" class="vc-text">{{ dialog.message }}</p>
            <span v-if="dialog.auth">
              <input
                v-focus
                v-model="password"
                @keyup.13="e => handleClickButton(e, true)"
                class="vc-input"
                type="password"
                name="vc-password"
                placeholder="Password"
                autocomplete="off"
              />
            </span>
          </span>
          <div
            class="vc-btn-grid"
            :class="{ isMono: !dialog.button.no || !dialog.button.yes }"
          >
            <button
              v-if="dialog.button.no"
              @click.stop="e => handleClickButton(e, false)"
              class="vc-btn left"
            >
              {{ dialog.button.no }}
            </button>

            <button
              v-if="dialog.button.yes"
              :disabled="dialog.auth ? !password : false"
              @click.stop="e => handleClickButton(e, true)"
              class="vc-btn"
            >
              {{ dialog.button.yes }}
            </button>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue'
import { events } from './events'

Vue.directive('focus', {
  inserted: function(el) {
    el.focus()
  }
})
const Component = {
  name: 'VueConfirmDialog',
  data() {
    return {
      isShow: false,
      password: null,
      dialog: {
        xclose: false,
        closebackground: false,
        auth: false,
        title: '',
        message: '',
        button: {}
      },
      params: {}
    }
  },
  methods: {
    resetState() {
      this.password = null
      this.dialog = {
        xclose: false,
        closebackground: false,
        auth: false,
        title: '',
        message: '',
        button: {},
        callback: () => {}
      }
    },
    handleClickButton({ target }, confirm) {
      if (target.id === 'vueConfirm') return
      if (confirm && this.dialog.auth && !this.password) return
      this.isShow = false
      // document.body.classList.remove('noscroll')
      // callback
      if (this.params.callback) {
        this.params.callback(confirm, this.password)
      }
    },
    handleClickOverlay({ target }) {
      if (this.dialog.closebackground && target.id === 'vueConfirm') {
        this.isShow = false
        // document.body.classList.remove('noscroll')
        // callback
        if (this.params.callback) {
          this.params.callback(null, this.password)
        }
      }
    },
    handleKeyUp({ keyCode }) {
      if (keyCode == 27) {
        this.handleClickOverlay({ target: { id: 'vueConfirm' } })
      }
      if (keyCode == 13) {
        this.handleClickButton({ target: { id: '' } }, true)
      }
    },
    open(params) {
      this.resetState()
      this.params = params
      this.isShow = true
      // document.body.classList.add('noscroll')
      // set params to dialog state
      Object.entries(params).forEach(param => {
        if (typeof param[1] == typeof this.dialog[param[0]]) {
          this.dialog[param[0]] = param[1]
        }
      })
    }
  },
  mounted() {
    if (!document) return
    events.$on('open', this.open)
    events.$on('close', () => {
      this.handleClickOverlay({ target: { id: 'vueConfirm' } })
    })
    // document.addEventListener('keyup', this.handleKeyUp)
  },
  beforeDestroy() {
    // document.removeEventListener('keyup', this.handleKeyUp)
  }
}
export default Component
</script>

<style lang="scss">
:root {
  --title-color: black;
  --message-color: black;
  --overlay-background-color: #0000004a;
  --container-box-shadow: #0000004a 0px 3px 8px 0px;
  --base-background-color: #ffffff;
  --button-color: #4083ff;
  --button-background-color: #ffffff;
  --button-border-color: #e0e0e0;
  --button-background-color-disabled: #f5f5f5;
  --button-background-color-hover: #f5f5f5;
  --button-box-shadow-active: inset 0 2px 0px 0px #00000014;
  --input-background-color: #ebebeb;
  --input-background-color-hover: #dfdfdf;
  --font-size-m: 16px;
  --font-size-s: 14px;
  --font-weight-black: 900;
  --font-weight-bold: 700;
  --font-weight-medium: 500;
  --font-weight-normal: 400;
  --font-weight-light: 300;
}
/**
* Dialog
*/
.vc-overlay *,
.vc-overlay *:before,
.vc-overlay *:after {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-decoration: none;
  -webkit-touch-callout: none;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
}
.vc-close {
  font-size: 18px;
  font-family: $font-CuratorRegular;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  cursor: pointer;
}
.vc-title {
  color: var(--title-color);
  padding: 0 1rem;
  width: 100%;
  text-align: center;
  line-height: initial;
  margin-bottom: 5px;
  /* font-weight: var(--font-weight-black);
  font-size: var(--font-size-m); */
  font-size: 18px;
  font-family: $font-CuratorBold;
}
.vc-text {
  color: var(--message-color);
  padding: 12px 0 15px;
  width: 100%;
  text-align: center;
  line-height: initial;
  /* font-weight: var(--font-weight-medium);
  font-size: var(--font-size-s); */
  font-size: 18px;
  font-family: $font-CuratorRegular;
}
.vc-overlay {
  background-color: var(--overlay-background-color);
  width: 100%;
  height: 100%;
  transition: all 0.1s ease-in;
  left: 0;
  top: 0;
  z-index: 999999999999;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: baseline;
}
.vc-container {
  background-color: var(--base-background-color);
  height: auto;
  display: grid;
  grid-template-rows: 1fr max-content;
  box-shadow: var(--container-box-shadow);
  /* border-radius: 1rem; */
  /* width: 286px; */
  border-radius: 5px;
  width: 85%;
  max-width: 400px;
}
.vc-text-grid {
  padding: 1rem;
  position: relative;
}
.vc-btn-grid {
  width: 100%;
  border-radius: 0 0 1rem 1rem;
  overflow: hidden;
  padding-bottom: 20px;
  text-align: center;
  /* display: grid; */
  display: inline-block;
}
.vc-btn-grid.isMono {
  grid-template-columns: 1fr;
}
.vc-btn {
  cursor: pointer;
  outline: none;
  /* border-radius: 0 0 1rem 0;
  min-height: 50px;
  border: 0;
  background-color: var(--button-background-color);
  border-top: 1px solid var(--button-border-color);
  color: var(--button-color);
  font-size: 1rem;
  font-weight: var(--font-weight-bold); */
  min-height: 30px;
  border: 1px solid #1D315C;
  border-radius: 25px;
  color: #FFF;
  font-size: 15px;
  font-family: $font-CuratorRegular;
  background-color: #1D315C;
  padding: 7px 20px;
}
.vc-btn:hover {
  /* background-color: var(--button-background-color-hover); */
}
.vc-btn:disabled {
  /* background-color: var(--button-background-color-disabled); */
  background-color: $greylight;
  color: $black;
}
.vc-btn:active {
  box-shadow: var(--button-box-shadow-active);
}
.vc-btn.left {
  /* border-radius: 0;
  border-right: 1px solid var(--button-border-color); */
  color: $black;
  background-color: unset;
  margin-right: 10px;
  border: 1px solid #999999;
}
.vc-input[type='password'] {
  width: 100%;
  outline: none;
  border-radius: 8px;
  height: 35px;
  border: 0;
  margin: 5px 0;
  background-color: var(--input-background-color);
  padding: 0 0.5rem;
  font-size: var(--font-size-m);
  transition: 0.21s ease;
}
.vc-input[type='password']:hover,
.vc-input[type='password']:focus {
  background-color: var(--input-background-color-hover);
}
/**
* Transition
*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.21s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.zoom-enter-active,
.zoom-leave-active {
  animation-duration: 0.21s;
  animation-fill-mode: both;
  animation-name: zoom;
}
.zoom-leave-active {
  animation-direction: reverse;
}
@keyframes zoom {
  from {
    opacity: 0;
    transform: scale3d(1.1, 1.1, 1.1);
  }
  100% {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}
body.noscroll {
  /* overflow: hidden; */
}
</style>
